namespace e5{
    export interface SvgCanvasLoaderOptions extends AjaxLoaderOptions {
        scale?: number | ((width: number, height: number) => number);
    }

    class SvgCanvasLoader extends AbstractAjaxLoader<HTMLCanvasElement, SvgCanvasLoaderOptions>{
        protected async convert(svg: SVGElement): Promise<HTMLCanvasElement> {
            /**
             * Get the "correct" intrinsic/natural
             * size of the svg. Like chrome use 150x150 as fallback.
             */
            var w = 150;
            var h = 150;

            if (svg.hasAttribute("width")) {
                w = parseFloat(svg.getAttribute("width"));
            } else if (svg.hasAttribute("viewBox")) {
                var values = svg.getAttribute("viewBox").split(/[\s,]+/i);
                if (values.length >= 4) {
                    w = parseFloat(values[2]);
                }
            }

            if (svg.hasAttribute("height")) {
                h = parseFloat(svg.getAttribute("height"));
            } else if (svg.hasAttribute("viewBox")) {
                var values = svg.getAttribute("viewBox").split(/[\s,]+/i);
                if (values.length >= 4) {
                    h = parseFloat(values[3]);
                }
            }

            var scale = 1;
            if (typeof this._options.scale === "function") {
                scale = this._options.scale(w, h);

            } else {
                scale = this._options.scale;
            }
            w *= scale;
            h *= scale;

            return new Promise<HTMLCanvasElement>(
                (resolve, reject) => {
                    //Make the svg size explicit!
                    svg.setAttribute("width", w + "");
                    svg.setAttribute("height", h + "");

                    //URI encode the svg.
                    var base64 = "";
                    if (Caps.isInternetExplorer) {
                        var s = new XMLSerializer().serializeToString(svg);
                        base64 = "data:image/svg+xml;base64," + window.btoa(s);
                    }
                    else {
                        base64 = "data:image/svg+xml;utf8," + encodeURIComponent(svg.outerHTML);
                        // var base64 = "data:image/svg+xml;base64," + window.btoa(svg.outerHTML);
                    }

                    var img = document.createElement("img");

                    img.onload = () => {
                        img.onerror = null;
                        img.onload = null;

                        var can = document.createElement("canvas");
                        can.width = w;
                        can.height = h;
                        var ctx = can.getContext("2d");
                        ctx.drawImage(img, 0, 0, w, h);
                        resolve(can);
                    }

                    img.onerror = (e) => {
                        reject(e);
                    }

                    img.src = base64;
                }
            );
        }

        protected defaultOptions(): SvgCanvasLoaderOptions {
            return {
                scale: 1,
                decoder: "svg"
            }
        }
    }

    export interface LoaderOptionsMap {
        "svgcanvas": SvgCanvasLoaderOptions;
    }
    
    export interface LoaderMap {
        "svgcanvas": SvgCanvasLoader;
    }

    registerLoader("svgcanvas", SvgCanvasLoader);
}